import React from 'react';
import { IoClose } from 'react-icons/io5';
import '../Filters/Filters.scss';
import BasicTooltip from '../Tooltip/BasicTooltip';

const FilterChip = ({ label, value, onClear, showClear = true, truncate = false
}) => {

  const shouldTruncate = truncate && value && value.length > 13;

  const displayValue = shouldTruncate
    ? `${value.slice(0, 10)}...`
    : value;

  return (
    <div className="filter-chip">
      <span className="filter-chip-text">
        {label ? <strong>{label}:{' '}</strong> : null}
        {
          shouldTruncate ? (
            <BasicTooltip text={value} placement="top" show={!shouldTruncate ? false : undefined}>
          <div>
            {displayValue}
          </div>
        </BasicTooltip>
          ) : displayValue
        }
      </span>
      {showClear && <button
        type="button"
        className="filter-chip-clear"
        onClick={onClear}
        aria-label={`Clear ${label} filter`}
      >
        <IoClose size={14} />
      </button>}
    </div>
  );
};

export default FilterChip;
